<template>
  <v-container
    id="payGroupSummary"
  >
    <v-progress-linear
      v-show="loading"
      indeterminate
      color="green"
    />
    <div>
      <div class="oe-summary-title">
        <v-btn
          class="mx-2"
          fab
          dark
          x-small
          :color="approvals.color"
          @click="displaySection = !displaySection"
        >
          <v-icon
            v-show="!displaySection"
            dark
          >
            mdi-arrow-expand-vertical
          </v-icon>
          <v-icon
            v-show="displaySection"
            dark
          >
            mdi-arrow-expand-horizontal
          </v-icon>
        </v-btn>
        Pay Group Summary
      </div>
      <v-fab-transition>
        <note
          v-show="displaySection"
          :open-enrollment="openEnrollment"
          :section="sections.payGroup"
          summary="true"
        />
      </v-fab-transition>
      <div
        v-if="!loading && payGroups && payGroups.length"
      >
        <div
          v-for="(payGroup, i) in payGroups"
          :key="i"
        >
          <v-fab-transition>
            <div
              v-show="displaySection"
              class="oe-summary-subsection mt-6"
            >
              <div class="text-center display-1">
                {{ payGroup.payGroup }}
              </div>
              <v-row>
                <v-col cols="6">
                  <base-display-value
                    v-model="payGroup.payFrequency"
                    label="Pay Frequency"
                  />
                </v-col>
                <v-col cols="6">
                  <base-display-value
                    v-model="payGroup.deductionFrequency"
                    label="Deduction Frequency"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <base-display-date
                    v-model="payGroup.firstPayrollCutoff"
                    label="First Pay Cutoff"
                  />
                </v-col>
                <v-col cols="6">
                  <base-display-date
                    v-model="payGroup.firstPayDate"
                    label="First Pay Date"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <base-display-value
                    v-model="payGroup.ongoingCutoff"
                    label="Ongoing Cutoff"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <base-display-value
                    v-model="payGroup.deduction"
                    label="Deduction"
                  />
                </v-col>
              </v-row>
            </div>
          </v-fab-transition>
        </div>
      </div>
      <v-fab-transition>
        <v-alert
          v-show="displaySection && (!loading && (!payGroups || !payGroups.length))"
          type="info"
        >
          No pay group details found
        </v-alert>
      </v-fab-transition>
      <v-fab-transition>
        <approval
          v-show="displaySection"
          :approvals="approvals"
          :allow-change="!print"
          @approval:changed="$emit('approval:changed')"
        />
      </v-fab-transition>
    </div>
    <base-material-snackbar
      v-model="displayError"
      type="error"
      v-bind="{
        top: true,
        right: true
      }"
    >
      {{ errorMessage }}
    </base-material-snackbar>
  </v-container>
</template>

<script>
  import TroodyApi from '@/services/troody/TroodyApi'
  import Approvals from '@/services/troody/Approvals'

  export default {
    name: 'PayGroupSummary',

    components: {
      Note: () => import('./Note'),
      Approval: () => import('./Approval'),
    },

    props: {
      expanded: {
        type: Boolean,
        default: false,
      },
      openEnrollment: {
        type: Object,
        default: null,
      },
      print: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      displaySection: true,

      loadingPayGroup: false,

      errorMessage: null,
      displayError: false,
      formErrors: {},

      payGroups: null,

      payGroupResource: new TroodyApi('oePayGroup/'),
      approvals: null,
    }),

    computed: {
      loading () {
        return (this.loadingPayGroup)
      },

      sections () {
        return Approvals.sections
      },
    },

    watch: {
      expanded (val) {
        this.displaySection = val
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        this.formErrors = {}
        this.loadPayGroup()
        this.approvals = new Approvals(this.openEnrollment.id, Approvals.sections.payGroup.id)
        this.displaySection = this.expanded
      },

      loadPayGroup () {
        this.loadingPayGroup = true
        this.payGroupResource.query({ openEnrollmentId: this.openEnrollment.id })
          .then(data => {
            console.log('payGroup')
            console.log(data)
            this.loadingPayGroup = false
            this.payGroups = data
          })
          .catch((error) => {
            this.loadingPayGroup = false
            this.payGroups = null
            this.showError(error, 'Failed to load pay group details!')
          })
      },

      showError (error, msg) {
        console.log(error)
        this.errorMessage = (error || msg)
        this.displayError = true
      },
    },
  }
</script>
